export const SearchResultsPageTestIds = {
  subcategoriesScrollGrid: 'subcategories-scroll-grid',
  subcategoriesScrollGridItem: 'subcategories-scroll-grid-item',
  collectionSelectDrawer: 'collection-select-drawer',
  collectionSelectOption: 'collection-select-option',
  vipAdsSection: 'vip-ads-section',
  latestAdsSection: 'latest-ads-section',
};
